import { MapPin, Phone, MessageSquare, Star } from "lucide-react";

export const OFFICES = [
  {
    id: "kampala",
    city: "Kampala",
    region: "Uganda · East Africa HQ",
    isHq: true,
    phones: ["+256 700 259 675", "+256 701 238 066", "+256 704 412 030"],
    whatsapp: "256700259675",
  },
  {
    id: "nyc",
    city: "New York City",
    region: "New York, USA",
    isHq: false,
    phones: ["+1 614 571 9333", "+1 617 291 6821"],
    whatsapp: "16145719333",
  },
  {
    id: "boston",
    city: "Boston",
    region: "Massachusetts, USA",
    isHq: false,
    phones: ["+1 617 291 6821"],
    whatsapp: "16172916821",
  },
  {
    id: "columbus",
    city: "Columbus",
    region: "Ohio, USA",
    isHq: false,
    phones: ["+1 614 571 9333"],
    whatsapp: "16145719333",
  },
];

export function OurOffices() {
  return (
    <section className="mt-16" data-testid="offices-section">
      <div className="eyebrow mb-3">Our Offices</div>
      <h2 className="font-display text-3xl md:text-4xl tracking-tighter">Locally present. Globally reachable.</h2>
      <p className="text-muted-foreground mt-3 max-w-2xl">
        We serve our clients locally and worldwide — walk in, call, or WhatsApp any of our offices.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
        {OFFICES.map((o) => (
          <div
            key={o.id}
            data-testid={`office-card-${o.id}`}
            className="bg-card rounded-2xl border-2 border-border hover:border-red-500 transition-colors duration-300 p-6 shadow-sm hover:shadow-xl relative overflow-hidden group"
          >
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-red-600" />
            {o.isHq && (
              <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-amber-400 text-slate-950 text-[10px] font-extrabold uppercase tracking-wider px-2 py-1 rounded-md">
                <Star className="w-3 h-3" /> HQ
              </span>
            )}
            <div className="flex items-center gap-2 text-red-600">
              <MapPin className="w-4 h-4" />
              <span className="text-[11px] font-bold uppercase tracking-[0.18em]">{o.region}</span>
            </div>
            <h3 className="font-display text-2xl font-bold mt-2">{o.city}</h3>

            <ul className="mt-4 space-y-1.5 text-sm text-muted-foreground">
              {o.phones.map((p) => (
                <li key={p}>
                  <a href={`tel:${p.replace(/\s+/g, "")}`} className="flex items-center gap-2 hover:text-red-600 transition-colors">
                    <Phone className="w-3.5 h-3.5 shrink-0" /> {p}
                  </a>
                </li>
              ))}
            </ul>

            <a
              href={`https://wa.me/${o.whatsapp}?text=${encodeURIComponent("Hi TIGAWA PROPERTIES, I'd like to talk to your " + o.city + " office")}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`office-whatsapp-${o.id}`}
              className="mt-5 inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-bold px-4 py-2 rounded-lg transition-colors active:scale-95"
            >
              <MessageSquare className="w-4 h-4" /> WhatsApp {o.city}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
